import InnerPageAAds from './InnerPageAAds';
export default InnerPageAAds;
